import { DOCUMENT_CALCULATION_FIELDS_SCHEMA_TYPE } from '../actions';

const initialState = {};

const documentCalculationFieldsRuleSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DOCUMENT_CALCULATION_FIELDS_SCHEMA_TYPE.GET_DOCUMENT_CALCULATION_FIELDS_RULE_SCHEMA_PARAMS:
      return payload || initialState;

    default:
      return state;
  }
};

export default documentCalculationFieldsRuleSchemaReducer;
